import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { AaNgModule } from 'aa-ng';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

import { BaseDirective, LoadingIndicatorService } from './shared';

@Component({
  selector: 'app-root',
  imports: [AaNgModule, AsyncPipe, RouterOutlet],
  template: `
    <router-outlet></router-outlet>
    <span *blocked="showLoading | async"></span>
  `,
})
export class EntryComponent extends BaseDirective {
  private loadingIndicatorService = inject(LoadingIndicatorService);
  router = inject(Router);

  showLoading = new BehaviorSubject(false);
  loading = new BehaviorSubject(false);
  forceLoading = new BehaviorSubject(false);
  @HostBinding('class') classes = '';
  constructor() {
    super();

    this._subscriptions.push(
      this.router.events.subscribe((routerEvent: Event) => {
        if (routerEvent instanceof NavigationStart) {
          this.loading.next(true);
          const urlTree = this.router.parseUrl(routerEvent.url);
          if (urlTree.root.hasChildren && urlTree.root.children['primary']) {
            this.classes = urlTree.root.children['primary'].segments
              .map((segment) => segment.path)
              .join(' ');
          } else {
            this.classes = 'landing';
          }
        }

        if (
          routerEvent instanceof NavigationEnd ||
          routerEvent instanceof NavigationCancel ||
          routerEvent instanceof NavigationError
        ) {
          this.loading.next(false);
        }
      }),
      this.loadingIndicatorService.forcedLoadingState.subscribe((state) => {
        this.forceLoading.next(state);
      }),
    );

    // Had to over engineer this part to avoid error "Value has been changed after checked"
    this._subscriptions.push(
      combineLatest([this.loading, this.forceLoading])
        .pipe(
          debounceTime(100),
          map(([loading, forceLoading]) =>
            this.showLoading.next(loading || forceLoading),
          ),
        )
        .subscribe(),
    );
  }
}
